import { render, staticRenderFns } from "./error_alert.vue?vue&type=template&id=463e605f"
import script from "./error_alert.vue?vue&type=script&lang=js"
export * from "./error_alert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports